export const CLINIC = {
  name: "Marimar Clinic",
  address: "Șoseaua Andronache nr. 52-54, Sector 2, București",
  hours: {
    weekdays: "Luni – Vineri: 09:00 – 19:00",
    saturday: "Sâmbătă: 09:00 – 12:00",
  },
  dental: {
    label: "Marimar Dental Clinic",
    phone: "0737 859 988",
    phoneRaw: "0737859988",
    waNumber: "40737859988",
    emails: ["contact@marimarclinic.ro", "office@marimarclinic.ro"],
    facebook: "https://www.facebook.com/profile.php?id=61565197940513",
    waMessage: (nume, telefon, mesaj) =>
      `Bună ziua! Doresc o programare la Marimar Dental Clinic. Numele meu este ${nume}. Telefon: ${telefon}. Mesaj: ${mesaj}.`,
  },
  fizio: {
    label: "Marimar Fizio & Kinetoterapie",
    phone: "0737 859 911",
    phoneRaw: "0737859911",
    waNumber: "40737859911",
    emails: ["marimargeneral@gmail.com"],
    facebook: "https://www.facebook.com/profile.php?id=61564404767385",
    waMessage: (nume, telefon, mesaj) =>
      `Bună ziua! Doresc o programare la Marimar Fizio & Kinetoterapie. Numele meu este ${nume}. Telefon: ${telefon}. Mesaj: ${mesaj}.`,
  },
};

export const MEDIA = {
  logo: "/assets/logo.svg",
  facade: "/assets/facade.jpg",
  dentalVideo: "/assets/dental.mp4",
  fizioVideo: "/assets/fizio.mp4",
  dentalImages: ["/assets/dental-clinic.jpg", "/assets/dental-clinic-2.jpg"],
  fizioImages: ["/assets/fizio-clinic.jpg", "/assets/fizio-clinic-2.jpg"],
  smile: "/assets/smile.jpg",
  team: "/assets/team.jpg",
};

export const DENTAL_SERVICES = [
  { icon: "Stethoscope", title: "Consultații stomatologice", text: "Evaluare completă, recomandări clare și plan de tratament personalizat." },
  { icon: "ScanLine", title: "Radiologie dentară", text: "Investigații rapide și precise pentru diagnostic corect și tratamente eficiente." },
  { icon: "Scissors", title: "Chirurgie dentară", text: "Intervenții realizate cu grijă, siguranță și atenție la confortul pacientului." },
  { icon: "Sparkles", title: "Estetică dentară", text: "Soluții pentru un zâmbet mai luminos, mai armonios și mai încrezător." },
  { icon: "Baby", title: "Pedodonție", text: "Stomatologie pentru copii, cu răbdare, blândețe și comunicare pe înțelesul celor mici." },
  { icon: "ShieldCheck", title: "Tratamente generale", text: "Îngrijire completă pentru sănătatea dinților și prevenirea problemelor dentare." },
];

export const FIZIO_SERVICES = [
  { icon: "Zap", title: "Fizioterapie", text: "Proceduri adaptate pentru reducerea durerii, inflamației și disconfortului." },
  { icon: "Activity", title: "Kinetoterapie", text: "Exerciții ghidate pentru mobilitate, forță, postură și recuperare funcțională." },
  { icon: "HeartPulse", title: "Recuperare medicală", text: "Planuri individuale pentru afecțiuni ale coloanei, articulațiilor și musculaturii." },
  { icon: "Spline", title: "Hernie de disc & lombare", text: "Abordare personalizată pentru reducerea durerii și îmbunătățirea mobilității." },
  { icon: "Baby", title: "Copii și nou-născuți", text: "Programe blânde, adaptate vârstei și nevoilor fiecărui copil." },
  { icon: "Gift", title: "Pachet promoțional", text: "4 proceduri – 10 ședințe – 500 RON. Recuperare completă la preț avantajos." },
];

export const STATS = [
  { value: "999+", label: "Proceduri efectuate" },
  { value: "99%", label: "Pacienți mulțumiți" },
  { value: "7", label: "Medici și specialiști" },
  { value: "20+", label: "Certificări și formări" },
];

export const REVIEWS = [
  { name: "Ion", text: "Am avut o experiență foarte bună la Dental Marimar. Medicul mi-a explicat fiecare etapă și m-am simțit în siguranță." },
  { name: "Amjad", text: "Am fost la fizioterapie și kinetoterapie. Echipa este profesionistă și lucrează foarte atent." },
  { name: "Dana", text: "Am ajuns cu dureri mari de spate, iar după câteva ședințe m-am simțit mult mai bine. Recomand." },
  { name: "Cristian", text: "Servicii stomatologice de calitate, echipă serioasă și foarte bine organizată." },
  { name: "Daniela", text: "Recomand clinica pentru profesionalism, răbdare și rezultate bune." },
  { name: "Georgiana", text: "Servicii de calitate și oameni care chiar îți explică ce ai de făcut." },
  { name: "Lori", text: "Super experiență și la stomatologie, și la fizio. Recomand cu drag." },
  { name: "Andreea", text: "Am venit cu teamă la dentist, dar totul a fost explicat calm și fără presiune." },
  { name: "Mihai", text: "Programare rapidă, tratament corect și personal foarte amabil." },
  { name: "Elena", text: "La kinetoterapie am simțit că primesc atenție reală, nu doar proceduri făcute pe fugă." },
  { name: "Raluca", text: "Clinica este curată, personalul politicos, iar medicii foarte atenți." },
  { name: "Bogdan", text: "Am apreciat faptul că mi s-a explicat planul de tratament înainte de orice intervenție." },
  { name: "Nicoleta", text: "Pentru copilul meu a fost o experiență bună la dentist. Multă răbdare și blândețe." },
  { name: "Alexandru", text: "Fizioterapia m-a ajutat mult după o perioadă lungă de dureri lombare." },
  { name: "Maria", text: "O clinică unde simți că ești ascultat și tratat cu respect." },
  { name: "Florin", text: "Recomand pentru seriozitate, aparatură modernă și prețuri decente." },
  { name: "Irina", text: "Am fost la Dental Marimar pentru estetică dentară și sunt foarte mulțumită." },
  { name: "Cătălin", text: "Kinetoterapia a fost făcută profesionist, cu explicații clare la fiecare exercițiu." },
  { name: "Alina", text: "Foarte bună comunicarea, programarea rapidă și atmosfera din clinică." },
  { name: "Sorin", text: "M-am simțit în siguranță, iar rezultatul tratamentului dentar a fost peste așteptări." },
  { name: "Oana", text: "Pentru recuperare medicală recomand cu încredere. Personal implicat și atent." },
  { name: "Vlad", text: "Mi-a plăcut că nu s-a grăbit nimeni și mi s-a explicat totul clar." },
  { name: "Roxana", text: "Am dus copilul la pedodonție și experiența a fost foarte plăcută." },
  { name: "Gabriel", text: "Servicii bune, oameni serioși și atmosferă prietenoasă." },
  { name: "Laura", text: "După ședințele de fizio, durerea s-a redus considerabil." },
  { name: "Darius", text: "Recomand pentru stomatologie. Tratament făcut cu grijă și profesionalism." },
  { name: "Simona", text: "O echipă caldă, atentă și bine pregătită." },
  { name: "Marian", text: "Am ajuns cu dureri la umăr și am primit un program foarte bine adaptat." },
  { name: "Patricia", text: "Clinica arată bine, personalul este amabil și programările sunt ușor de făcut." },
  { name: "Liviu", text: "Experiență foarte bună. Recomand Marimar Clinic pentru seriozitate și rezultate." },
];

export const NAV_LINKS = [
  { href: "#acasa", label: "Acasă" },
  { href: "#dental", label: "Dental" },
  { href: "#fizio", label: "Fizio & Kineto" },
  { href: "#servicii", label: "Servicii" },
  { href: "#recenzii", label: "Recenzii" },
  { href: "#contact", label: "Contact" },
];

export const buildWaUrl = (number, message) =>
  `https://wa.me/${number}?text=${encodeURIComponent(message)}`;
